import api from './api';

export const treeDataService = {
  // Get all groups with nested products and vendors
  getAllGroups: async () => {
    return await api.get('/groups');
  },

  // Create new group
  createGroup: async (m_name, profile) => {
    console.log(m_name)
    return await api.post('/groups', { m_name, profile });
  },

  // Update group
  updateGroup: async (id, name) => {
    // Extract numeric ID from "g123" format
    const numericId = parseInt(id.replace('g', ''));
    return await api.put(`/groups/${numericId}`, { id: numericId, name });
  },

  // Delete group
  deleteGroup: async (id) => {
    const numericId = parseInt(id.replace('g', ''));
    return await api.delete(`/groups/${numericId}`);
  },

  // Create new product
  createProduct: async (groupId, m_name) => {
    const numericGroupId = parseInt(groupId.replace('g', ''));
    return await api.post('/products', { m_group_id: numericGroupId, m_name });
  },

  // Update product
  updateProduct: async (id, m_name, groupId) => {
    const numericId = parseInt(id.replace('p', ''));
    const numericGroupId = parseInt(groupId.replace('g', ''));
    return await api.put(`/products/${numericId}`, {
      m_id: numericId,
      m_group_id: numericGroupId,
      m_name
    });
  },

  // Delete product
  deleteProduct: async (id) => {
    const numericId = parseInt(id.replace('p', ''));
    return await api.delete(`/products/${numericId}`);
  },

  // Create new vendor
  createVendor: async (productId, vendorData) => {
    console.log(vendorData)
    console.log(productId)
    const numericProductId = parseInt(productId.replace('p', ''));
    console.log(numericProductId)
    const dat = {
      m_product_id: numericProductId,
      m_name: vendorData.m_name,
      m_email: vendorData.m_email || '',
      m_phone: vendorData.m_phone || '',
      m_contact_person: vendorData.m_contact_person || '',
      m_email2: vendorData.m_email2 || '',
      m_phone2: vendorData.m_phone2 || '',
      m_contact_person2: vendorData.m_contact_person2 || '',
      m_company: vendorData.m_company || '',
      m_address: vendorData.m_address || '',
      m_contract_start: vendorData.m_contract_start || null,
      m_contract_end: vendorData.m_contract_end || null,
      m_status: vendorData.m_status || 'Pending',
      m_last_message: vendorData.m_last_message || 'New vendor'
    };
    console.log(dat);
    return await api.post('/vendors', dat);
  },

  // Update vendor
  updateVendor: async (id, vendorData) => {
    const m_id = parseInt(id.replace('v', ''));
    const numericProductId = parseInt(vendorData.productId?.replace('p', '') || '0');

    const payload = {
      m_id: m_id,
      m_product_id: numericProductId,
      m_name: vendorData.m_name || "",
      m_email: vendorData.m_email || "",
      m_phone: vendorData.m_phone || "",
      m_contact_person: vendorData.m_contact_person || "",
      m_email2: vendorData.m_email2 || "",
      m_phone2: vendorData.m_phone2 || "",
      m_contact_person2: vendorData.m_contact_person2 || "",
      m_company: vendorData.m_company || "",
      m_address: vendorData.m_address || "",
      //m_contract_start: vendorData.m_contract_start,
      //m_contract_end: vendorData.m_contract_end,

      m_contract_start: vendorData.m_contract_start
        ? new Date(vendorData.m_contract_start).toISOString()
        : null,
      m_contract_end: vendorData.m_contract_end
        ? new Date(vendorData.m_contract_end).toISOString()
        : null,

      m_status: vendorData.m_status || "",
      m_last_message: vendorData.m_last_message || "",

    }

    console.log("FINAL PAYLOAD:", payload);

    return await api.put(`/Vendors/${m_id}`, payload);
  },

  // Delete vendor
  deleteVendor: async (id) => {
    const numericId = parseInt(id.replace('v', ''));
    return await api.delete(`/vendors/${numericId}`);
  },

  // Get messages for vendor
  getVendorMessages: async (vendorId) => {
    const numericId = parseInt(vendorId.replace('v', ''));
    return await api.get(`/messages/vendor/${numericId}`);
  },

  // Create message
  createMessage: async (vendorId, messageData) => {
    const numericVendorId = parseInt(vendorId.replace('v', ''));
    return await api.post('/messages', {
      m_vendor_id: numericVendorId,
      m_type: messageData.m_type,
      m_text: messageData.m_text,
      user: messageData.user
    });
  }
};